import { useMemo } from "react";
import { Box, Heading, Tooltip, Icon, HStack } from "@chakra-ui/react";
import { Info } from "lucide-react";

import FilterForm from "../../components/FilterForm";
import { useSelector } from "react-redux";
import { REPORT_RANGES, REPORT_TYPE_IDS } from "../../store/constants";
import Loader from "../../components/loader";
import {
  getReportDescription,
  getReportRangeString,
} from "../../store/helpers";
import BranchCustomersInBranchPerHourReport from "../../components/branches/reports/BranchCustomersInBranchPerHour";
import _ from "lodash";
import { Helmet } from "react-helmet";
import DownloadReport from "../../components/DownloadReport";
import SelectBranchInfo from "../../components/misc/SelectBranchInfo";
import ReportPresentationControls from "../../components/reports/ReportPresentationControls";
import ReportPresentationSummary from "../../components/reports/ReportPresentationSummary";
import { CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS } from "../../store/renderConfig";
import { useReportPresentation } from "../../hooks/useReportPresentation";
import { downloadCustomersInBranchCsvFiles } from "../../store/customersInBranchExport";

const BranchCustomersInBranchPerHour = ({
  showFilterForm = true,
  reportIndex = 1,

  showTitle = 1,
}) => {
  const { loading, reportRange, reportsData, branchId } = useSelector(
    (state) => state.defaultReducer
  );

  const reportTypeId =
    reportRange === REPORT_RANGES.WEEK
      ? REPORT_TYPE_IDS.weekly_branch_customers_in_branch_per_hour
      : REPORT_TYPE_IDS.monthly_branch_customers_in_branch_per_hour;

  
  let reports = reportsData.filter((a) => a.reportTypeId === reportTypeId);
  if (branchId.length > 0) {
    reports = reports.filter((a) => a.branchId === branchId);
  }
  const data = reports.map((a) => a.data) || [];
  const {
    effectiveRenderConfig,
    isSaving,
    presentationSummaryItems,
    saveRenderConfig,
    setRenderConfig,
  } = useReportPresentation({
    reportTypeId,
    columnDefinitions: CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS,
  });
  const csvScopes = useMemo(
    () => data.map((row) => ({ ...row, scopeName: row.branchName })),
    [data]
  );

  const title = `Customers In Branch Per Hour`;

  return (
    <Box>
      {showTitle === 1 && (
        <Helmet>
          <title>
            {getReportRangeString(reportRange)} Branch Customers In Branch Per
            Hour
          </title>
        </Helmet>
      )}
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {!_.isEmpty(data) ? (
            <>
              <HStack flexDirection={"row"} justifyContent={"space-between"}>
                <Heading fontSize="34px" color="#222" fontWeight="700">
                  {title}

                  <Tooltip.Root>
                    <Tooltip.Trigger asChild>
                      <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
                    </Tooltip.Trigger>
                    <Tooltip.Positioner>
                      <Tooltip.Content>
                        {getReportDescription(reportRange)
                          .BranchesCustomersInBranchPerHour}
                      </Tooltip.Content>
                    </Tooltip.Positioner>
                  </Tooltip.Root>
                </Heading>
                <DownloadReport
                  reportRange={reportRange}
                  reportTypeId={reportTypeId}
                  renderConfig={effectiveRenderConfig}
                  onSave={saveRenderConfig}
                  isSaving={isSaving}
                  onDownloadCsv={() =>
                    downloadCustomersInBranchCsvFiles({
                      scopes: csvScopes,
                      renderConfig: effectiveRenderConfig,
                      filenamePrefix: "branch_customers_in_branch_per_hour",
                    })
                  }
                />
              </HStack>
              <ReportPresentationControls
                renderConfig={effectiveRenderConfig}
                onChange={setRenderConfig}
                columnDefinitions={CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS}
                defaultSortColumn="average"
              />
              <ReportPresentationSummary items={presentationSummaryItems} />
              <BranchCustomersInBranchPerHourReport
                data={data}
                reportIndex={reportIndex}
                renderConfig={effectiveRenderConfig}
                onRenderConfigChange={setRenderConfig}
              />
            </>
          ) : (
            (
        <SelectBranchInfo message={'Update Filters and Hit Search to retrieve data'}/>
      )
          )}
        </>
      )}
    </Box>
  );
};

export default BranchCustomersInBranchPerHour;
